import React, { FC, HTMLProps } from 'react';
import clsx from 'clsx';

import { BANNER_TEST_ID } from 'components/Banner/const';

import styles from './styles.module.scss';

export const Banner: FC<HTMLProps<HTMLDivElement>> = ({ children, className }) => (
  <div data-testid={BANNER_TEST_ID} className={clsx(styles.banner, className)}>
    {children}
  </div>
);
